import { Field, FieldProps } from "formik";
import { MuiColorInput } from "mui-color-input";
import { ReactElement } from "react";

export function FormikColorPickerField({
  name,
  label,
  fullWidth,
}: {
  name: string;
  label: string;
  fullWidth?: boolean;
}): ReactElement {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <MuiColorInput
          fullWidth={fullWidth}
          label={label}
          format="hex"
          isAlphaHidden
          value={field.value}
          onChange={newValue => form.setFieldValue(field.name, newValue)}
          sx={{ ".MuiInputAdornment-root": { marginLeft: "8px" } }}
        />
      )}
    </Field>
  );
}
